import $ from 'jquery'

export default {
    name: 'antecedent-neonatologie-geniteur',
    components: {},
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        current_consultation_evolution: Number
    },
    data() {
        return {
            is_loading: true,
            is_empty: false,
            visible_collapse: 1,

            save_loading: false,
            
            atcd_allergo_p: {
                v_model: []
            },
            fields: [
                'geniteur_pere', 'geniteur_pere_age', 'geniteur_pere_gsrh', 'geniteur_pere_hb',
                'geniteur_mere', 'geniteur_mere_age', 'geniteur_mere_gsrh', 'geniteur_mere_hb',
                'geniteur_gestite', 'geniteur_parite', 'geniteur_enf_vivant',
                'grossesse_vat2', 'grossesse_3cpn', 'grossesse_bilan_tpha', 'grossesse_bilan_vdrl',
                'grossesse_bilan_aghbs', 'grossesse_bilan_toxo', 'grossesse_bilan_rubeole', 
                'grossesse_bilan_vih',  'grossesse_bilan_type_vih', 'grossesse_date_depistage', 'grossesse_debut_arv', 
                'grossesse_traitement_encours', 'grossesse_ecographies',
                'pathologie_infection_urinaire', 'pathologie_infection_genitale', 'pathologie_palusisme',
                'pathologie_anemie', 'pathologie_dysgravidie', 'pathologie_autres', 'pathologie_hospitalisation',
                'pathologie_hospitalisation_duree', 'pathologie_hospitalisation_motif', 
                'accouchement_agent', 'accouchement_centre', 'accouchement_semaine_aménorrhée', 'accouchement_date',
                'accouchement_heure', 'accouchement_hyperthermie_maternelle', 'accouchement_hyperthermie_celcius',
                'accouchement_rupture_premature',  'accouchement_rupture_duree', 'accouchement_duree_travail',
                'accouchement_aspect_la', 'accouchement_manoeuvre_obstetricale', 'accouchement_cesarienne', 
                'accouchement_motif_cesarienne', 
                'nouveau_ne_sexe', 'nouveau_ne_poids', 'poids_unit', 'nouveau_ne_taille', 'nouveau_ne_pc', 'nouveau_ne_pt',
                'nouveau_ne_apgar', 'nouveau_ne_reanimation', 'nouveau_ne_geste_effectue', 'nouveau_ne_apnee_secondaire', 
                'nouveau_ne_apnee_duree', 'nouveau_ne_soins_vitk1', 'nouveau_ne_soins_collyre_antiseptique', 
                'nouveau_ne_soins_mise_au_sein', 'nouveau_ne_soins_chlorxy_gel', 
                'nouveau_ne_transfert_motif', 'nouveau_ne_transfert_date', 'nouveau_ne_transfert_heure', 
                'nouveau_ne_transfert_agent_responsable'
            ],
        }
    },

    // poid_unit 48

    computed: {
        antecedent_neonatologie() {
            return this.$store.getters["antecedent_neonatologie"];
        },
    },

    mounted() {
        this.listeChampATCDNeonatologie()
    },

    methods: {
        initFields() {
            var i = 0
            
            this.fields.forEach((fld, index) => {
                var v = ''
                if (this.antecedent_neonatologie.length > 0) {
                    v = this.antecedent_neonatologie[index]['field_content']
                } else {
                    if (fld == 'poids_unit') {
                        v = 'Kg'
                    }
                }
                
                this.atcd_allergo_p.v_model.push({
                    field_name: fld,
                    value: v
                })
                i++

                if (i == (this.fields.length - 1)) {
                    this.is_loading = false
                }
            });
        },

        async listeChampATCDNeonatologie() {
            this.is_loading = true
            
            let filter_data = {
                evolution_id: this.evolution_id,
                consultation_id: this.consultation.id,
                data_type: 'antecedent_neonatologie',
                est_en_cours: true
            }

            this.$store.dispatch('getConsultationAntecedent', filter_data).then(() => {
                console.log("Neo: ", this.antecedent_neonatologie);
                
                this.initFields()
            })
        },

        toggleSection(value) {
            this.visible_collapse = value
        },

        async formatComma(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,.]+/g, ''))
        },

        /**
         * Format input to only digit
         * @param {*} selector 
         */
        async onlyDigit(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9]+/g, ''))
        },

        async onlyDigitSlash(selector) {
            $('#' + selector).val($('#' + selector).val().replace(/[^0-9,/]+/g, ''))
        },

        saveAntecedent() {
            this.save_loading = true

            let data = {
                consultation_id: this.consultation.id,
                data_type: 'antecedent_neonatologie',
                antecedents: this.atcd_allergo_p.v_model
            }

            this.$store.dispatch('saveConsultationAntecedent', data).then((response) => {
                console.log(response)
                if (response > 0) {
                    this.listeChampATCDNeonatologie()
                }

                this.save_loading = false
            })
        }
    }
}


